/**
 * Root gate — decides what `/` renders.
 *   - Logged in   → bounce to `/home` (the app shell)
 *   - Logged out  → render the public landing / coming-soon splash
 *
 * Kept tiny on purpose: any heavier logic belongs in the components
 * themselves, not the router.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ComingSoon from '../pages/ComingSoon';

const RootGate = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#0052FF]" />
      </div>
    );
  }

  if (user) return <Navigate to="/home" replace />;
  return <ComingSoon />;
};

export default RootGate;
